<template>
    <section class="border-border-light dark:border-border-dark space-y-4 border-t pt-6">
        <h3 class="text-text-light dark:text-text-dark text-sm font-semibold">
            {{ trans('maintainers.sla.agreement_term.title') }}
        </h3>

        <div class="grid grid-cols-1 items-start gap-4 md:grid-cols-2">
            <div class="flex h-full w-full flex-col">
                <label class="form-label">
                    {{ trans('maintainers.sla.expected_uptime_timespan.title') }}
                </label>
                <div class="flex flex-1 items-center pt-3">
                    <jet-slider
                        v-model="modelValue.expectedUptimeDaily"
                        :full-width-with-value-below="true"
                        :horizontal="false"
                        :invalid-feedback="modelValue.errors['expectedUptimeDaily.start']"
                        :max="1440"
                        :min="0"
                        :inline="true"
                        :step-size="5"
                        class="w-full"
                    />
                </div>
            </div>
            <div class="flex h-full w-full flex-col">
                <label class="form-label">
                    {{ trans('maintainers.sla.expected_uptime_percentage.title') }}
                </label>
                <div class="flex flex-1 items-center pt-3">
                    <jet-input
                        v-model="modelValue.expectedUptimeMonthlyPercentage"
                        :horizontal="false"
                        :invalid-feedback="modelValue.errors.expectedUptimeMonthlyPercentage"
                        :inline="true"
                        class="w-full"
                        type="text"
                        @blur="sanitizeNumber"
                    >
                        <template #append>%</template>
                    </jet-input>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div class="space-y-1">
                <label class="form-label">
                    {{ trans('maintainers.sla.agreement_term.from.title') }}
                </label>
                <jet-datepicker
                    :horizontal="false"
                    :invalid-feedback="modelValue.errors.startDate"
                    :model-value="modelValue.startDate"
                    @update:model-value="setStartDate"
                />
            </div>

            <div class="space-y-1">
                <label class="form-label">
                    {{ trans('maintainers.sla.agreement_term.to.title') }}
                </label>
                <jet-datepicker
                    :horizontal="false"
                    :invalid-feedback="modelValue.errors.endDate"
                    :min-date="modelValue.startDate"
                    :model-value="modelValue.endDate"
                    @update:model-value="setEndDate"
                />
            </div>
        </div>
    </section>
</template>

<script setup>
import JetDatepicker from '@/Jetstream/Datepicker.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetSlider from '@/Jetstream/Slider.vue';
import { trans } from '@/mixins/i18n';
import { normalizeNumber } from '@/Utils/normalizeNumber';

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});

function setStartDate(date) {
    props.modelValue.startDate = date;
}

function setEndDate(date) {
    props.modelValue.endDate = date;
}

function sanitizeNumber() {
    props.modelValue.expectedUptimeMonthlyPercentage = normalizeNumber(props.modelValue.expectedUptimeMonthlyPercentage)?.toString();
}
</script>
